import { filter } from "lodash";
// import React from 'react';
import React, { useEffect, useState } from "react";
// import { useEffect, useState } from 'react';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Button,
  MenuItem,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
// components
import Page from "../components/Page";

import Scrollbar from "../components/Scrollbar";

import SearchNotFound from "../components/SearchNotFound";
import {
  UserListHead,
  UserListToolbar,
  UserMoreMenu,
} from "../sections/@dashboard/user";
// mock
import { useNavigate } from "react-router-dom";
import SyncLoader from "react-spinners/SyncLoader";
import { ExportCSV } from "../utils/ExportCSV";
import { ToastContainer, toast } from "react-toastify";

// for Dialog box
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios"; // for axios request

import { CSVLink } from "react-csv"; // for CSV file download
import { RHFTextField } from "../components/hook-form";

import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ro } from "date-fns/locale";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "", label: "S.No", alignRight: false },
  { id: "enrolid", label: "Enrollment No.", alignRight: false },
  { id: "StudentName", label: "Name", alignRight: false },
  { id: "mobileNumber", label: "Phone No.", alignRight: false },
  { id: "email", label: "Email", alignRight: false },
  { id: "value", label: "Batch/Test Series", alignRight: false },
  { id: "purchaseAt", label: "Purchased At", alignRight: false },
  { id: "paid", label: "Paid", alignRight: false },
  { id: "Status", label: "Status", alignRight: false },
  { id: "Action", label: "Action", alignRight: false },
];

// ----------------------------------------------------------------------

function parseDMYDate(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return new Date(0);
  const parts = dateStr.trim().split(" ");
  const dateParts = parts[0].split("-");
  const timeParts = parts[1] ? parts[1].split(":") : ["00", "00", "00"];
  return new Date(
    parseInt(dateParts[2], 10),
    parseInt(dateParts[1], 10) - 1,
    parseInt(dateParts[0], 10),
    parseInt(timeParts[0], 10),
    parseInt(timeParts[1], 10),
    parseInt(timeParts[2], 10)
  );
}

function formatDateTimeIST(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return "N/A";
  const parsedDate = parseDMYDate(dateStr);
  if (isNaN(parsedDate.getTime())) return dateStr;
  
  const day = String(parsedDate.getDate()).padStart(2, '0');
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const year = parsedDate.getFullYear();
  
  let hours = parsedDate.getHours();
  const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  
  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}

function descendingComparator(a, b, orderBy) {
  let valA = a[orderBy];
  let valB = b[orderBy];
  if (orderBy === "purchaseAt") {
    valA = parseDMYDate(valA);
    valB = parseDMYDate(valB);
  }
  if (valB < valA) {
    return -1;
  }
  if (valB > valA) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(array, (_user) => {
      const studentNameMatch =
        _user?.user?.name &&
        _user?.user?.name.toLowerCase().includes(query.toLowerCase());
      const emailMatch =
        _user?.user?.email &&
        _user?.user?.email.toLowerCase().includes(query.toLowerCase());
      const phoneMatch =
        _user?.mobileNumber &&
        _user.mobileNumber.toLowerCase().includes(query.toLowerCase());
      return studentNameMatch || emailMatch || phoneMatch;
    });
  }

  return stabilizedThis.map((el) => el[0]);
}
export default function Students() {
  //date-time
  const [starting, setStarting] = React.useState(dayjs().startOf('day'));
  const [ending, setEnding] = React.useState(dayjs().endOf('day'));
  const [dateRangeOption, setDateRangeOption] = useState("today");
  const [searched, setSearched] = useState(true);

  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState({
    enrollId: true,
    name: true,
    phone: true,
    email: true,
    category: true,
    value: true,
    purchaseAt: true,
    is_paid: true,
    is_active: true,
    amount: true,
    txnId: false,
  });

  const handleColumnToggle = (column) => {
    setSelectedColumns(prev => ({
      ...prev,
      [column]: !prev[column]
    }));
  };

  const handleChange = (newValue) => {
    setStarting(newValue);
    setDateRangeOption("custom");
  };
  const handleChangeTwo = (newValue) => {
    setEnding(newValue);
    setDateRangeOption("custom");
  };

  const handleDateRangeOptionChange = (event) => {
    const option = event.target.value;
    setDateRangeOption(option);
    const now = dayjs();
    let newStarting = starting;
    let newEnding = ending;

    if (option === "today") {
      newStarting = now.startOf("day");
      newEnding = now.endOf("day");
    } else if (option === "1week") {
      newStarting = now.subtract(1, "week");
      newEnding = now;
    } else if (option === "1month") {
      newStarting = now.subtract(1, "month");
      newEnding = now;
    }

    setStarting(newStarting);
    setEnding(newEnding);
  };

  // Code for handling Dialog box
  const [showDownload, setShowDownload] = useState(false);
  const [download, setDownload] = useState(true);
  const [statusUser, setStatusUser] = useState();
  const [statusStaus, setStatusStatus] = useState();
  const [errorOTP, setErrorOtp] = useState();
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const sendOtp = () => {
    const token = localStorage.getItem("token");
    const authToken = token;
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    const data = {
      action: "Exporting All Users Data",
    };

    axios
      .post(
        `${process.env.REACT_APP_LIVE_URL}/adminTeacher/send-otp`,
        data,
        config
      )
      .then((response) => {})
      .catch((e) => {
        //console.log(e);
      });
  };
  const verifyOtp = () => {
    //console.log(document.getElementById('name').value);
    const token = localStorage.getItem("token");
    const authToken = token;
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    const data = {
      otp: document.getElementById("name").value,
    };

    axios
      .post(
        `${process.env.REACT_APP_LIVE_URL}/adminTeacher/verify-otp`,
        data,
        config
      )
      .then((response) => {
        // //console.log(response);
        if (response.data.status == false) {
          setErrorOtp("Invalid Otp");
        } else {
          if (showDownload) {
            setShowDownload(false);
            setDownload(false);
          } else {
            //console.log("status");
            //console.log(statusStaus);
            const data1 = {
              isActive: !statusStaus,
            };
            axios
              .post(
                `${process.env.REACT_APP_LIVE_URL}/adminTeacher/activeInactiveStudent/${statusUser}`,
                data1,
                config
              )
              .then((response) => {
                //console.log(response);
              });

            handleClose();

            toast.success("Status Updated");
            setTimeout(() => window.location.reload(), 1000);

            setErrorOtp("");
          }
        }
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState("desc");

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState("purchaseAt");

  const [filterName, setFilterName] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate();
  const [users, usersSet] = useState();
  const [loading, setLoading] = useState(true);
  const [filterSearch, setFilterSearch] = useState([]);

  //Getting Details
  useEffect(() => {
    const token = localStorage.getItem("token");
    async function fetchUsers() {
      const fullResponse = await fetch(
        `${process.env.REACT_APP_LIVE_URL}/adminTeacher/admingetallstudentsdetails`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const responseJson = await fullResponse.json();
      usersSet(responseJson.data);
      // //console.log(responseJson.data);
      setLoading(false);
      if (responseJson.msg === "not an admin") {
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("details");
        navigate("/");
      }
    }

    fetchUsers();
  }, []);

  const [type, setType] = useState("batch");
  const [valueId, setValueId] = useState('all');
  const [list, setList] = useState();
  // const [type,setType]=useState();

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InNkY2FtcHVzQHRyYW5kby5pbiIsInN0dWRlbnRJZCI6IjNjZjcwODYwLTZjMWMtMTFlZC04YjVlLWMxZjc4OTdkMzM5OCIsImlhdCI6MTY5NjkxMzkwNSwiZXhwIjoxNjk3MDg2NzA1fQ.6fO3U1pCsbTOO2AVgjDOohKa4b73wtyG9o3zLksTJk8";
    async function fetchUsers() {
      // const fullResponse = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminPanel/getBatchesDetails`, {
      const fullResponse = await fetch(
        `${process.env.REACT_APP_LIVE_URL}/adminPanel/${
          type == "batch" ? "getBatchesDetails" : "getallTestSeriesdetails"
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const responseJson = await fullResponse.json();
      setList(responseJson.data);
      setLoading(false);
      setValueId('all');
      handleFilter(type, 'all', dayjs().startOf('day'), dayjs().endOf('day'), responseJson.data);
    }
    fetchUsers();
  }, [type]);

  // useEffect(() => {
  //   handleFilter("batch", "all");
  // }, []);

  // console.log('296',valueId)

  // console.log('292',list)
  const handleFilter = async (selectedType, valueIdType, customStart, customEnd, customList) => {
    setSearched(true);
    let token = localStorage.getItem("token");
    const targetType = selectedType || type;
    const targetValueId = valueIdType || valueId;
    const activeList = customList || list;

    // Use a very wide date range for the backend to bypass MongoDB lexicographical comparison bugs
    const backendStart = new Date("2000-01-01T00:00:00Z");
    const backendEnd = new Date("2099-12-31T23:59:59Z");

    try {
      if (targetValueId === "all") {
        if (activeList && activeList.length > 0) {
          const promises = activeList.map(async (item) => {
            const singleData = {
              type: targetType,
              valueId: item._id,
              startAt: backendStart,
              endAt: backendEnd
            };
            const singleRes = await fetch(
              `${process.env.REACT_APP_LIVE_URL}/adminPanel/purchaseReport`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(singleData),
              }
            );
            const singleResult = await singleRes.json();
            return singleResult.data || [];
          });
          const allResults = await Promise.all(promises);
          const combined = allResults.flat();
          // Sort by purchaseAt descending
          combined.sort((a, b) => new Date(b.purchaseAt) - new Date(a.purchaseAt));
          setFilterSearch(combined);
        } else {
          setFilterSearch([]);
        }
      } else {
        const data = {
          type: targetType,
          valueId: targetValueId,
          startAt: backendStart,
          endAt: backendEnd
        };
        const res = await fetch(
          `${process.env.REACT_APP_LIVE_URL}/adminPanel/purchaseReport`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ ...data }),
          }
        );
        const result = await res.json();
        setFilterSearch(result.data || []);
      }
    } catch (error) {
      setFilterSearch([]);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = users?.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const getFilteredByDate = () => {
    if (!filterSearch) return [];
    const startVal = starting ? (starting.$d || starting) : null;
    const endVal = ending ? (ending.$d || ending) : null;
    
    return filterSearch.filter(item => {
      if (!item.purchaseAt) return false;
      const itemDate = parseDMYDate(item.purchaseAt);
      if (startVal && itemDate < new Date(startVal)) return false;
      if (endVal && itemDate > new Date(endVal)) return false;
      return true;
    });
  };


  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users?.length) : 0;

  const filteredUsers = searched
    ? applySortFilter(
        getFilteredByDate(),
        getComparator(order, orderBy),
        filterName
      )
    : [];

  const csvData = filteredUsers.map((item) => {
    const rowData = {};
    if (selectedColumns.enrollId) rowData["Enrollment No."] = item?.user?.enrollId || "N/A";
    if (selectedColumns.name) rowData["Name"] = item?.user?.name || "N/A";
    if (selectedColumns.phone) rowData["Phone No."] = item?.user?.phone || "N/A";
    if (selectedColumns.email) rowData["Email"] = item?.user?.email || "N/A";
    if (selectedColumns.category) rowData["Stream/Category"] = item?.user?.category || "N/A";
    if (selectedColumns.value) rowData["Batch/Test Series"] = item?.value || "N/A";
    if (selectedColumns.purchaseAt) rowData["Purchased At"] = item.purchaseAt ? formatDateTimeIST(item.purchaseAt) : "N/A";
    if (selectedColumns.is_paid) rowData["Paid Status"] = item.is_paid ? "Paid" : "Not Paid";
    if (selectedColumns.is_active) rowData["Status"] = item.is_active ? "Active" : "Inactive";
    if (selectedColumns.amount) rowData["Amount"] = item.amount || 0;
    if (selectedColumns.txnId) rowData["Transaction ID"] = item?.txnId || "N/A";
    return rowData;
  });
  // console.log(csvData);
  const isUserNotFound = filteredUsers?.length === 0;
  let i = 0;
  return (
    <>
      {loading ? (
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ height: "100%" }}
        >
          {" "}
          <SyncLoader color="red" loading={loading} size={20} />
        </Stack>
      ) : (
        <Page title="Students">
          <Container sx={{ position: "absolute", minWidth: "100%" }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Typography variant="h3" gutterBottom>
                All Purchase Report
              </Typography>
            </Stack>

            <Card
              sx={{
                width: "100%",
                padding: "16px 24px",
                marginBottom: "20px",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "16px",
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
              }}
            >
              <TextField
                name="type"
                label="Type"
                select
                size="small"
                value={type}
                onChange={(e) => setType(e.target.value)}
                sx={{ flexGrow: 1, minWidth: "120px" }}
              >
                <MenuItem value="batch">Batch</MenuItem>
                <MenuItem value="testseries">Test Series</MenuItem>
              </TextField>
              <TextField
                name="valueId"
                label={type == "batch" ? "All Batches" : "All Test Series"}
                select
                size="small"
                value={valueId}
                onChange={(e) => setValueId(e.target.value)}
                sx={{ flexGrow: 2, minWidth: "180px" }}
              >
                <MenuItem value="all">All</MenuItem>
                {list?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={item?._id}
                    >
                      {type == "batch"
                        ? item?.batch_name
                        : item?.testseries_name}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                name="dateRangeOption"
                label="Date Preset"
                select
                size="small"
                value={dateRangeOption}
                onChange={handleDateRangeOptionChange}
                sx={{ flexGrow: 1, minWidth: "120px" }}
              >
                <MenuItem value="today">Today</MenuItem>
                <MenuItem value="1week">1 Week</MenuItem>
                <MenuItem value="1month">1 Month</MenuItem>
                <MenuItem value="custom">Custom</MenuItem>
              </TextField>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ alignItems: "center", flexGrow: 3, minWidth: "360px" }}
                >
                  <DateTimePicker
                    label="From"
                    value={starting}
                    onChange={handleChange}
                    inputFormat="DD/MM/YYYY hh:mm A"
                    renderInput={(params) => (
                      <TextField {...params} size="small" sx={{ flexGrow: 1, width: "100%" }} />
                    )}
                  />
                  <DateTimePicker
                    label="To"
                    value={ending}
                    onChange={handleChangeTwo}
                    inputFormat="DD/MM/YYYY hh:mm A"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ flexGrow: 1, width: "100%" }}
                      />
                    )}
                  />
                </Stack>
              </LocalizationProvider>

              <Button variant="contained" onClick={() => handleFilter(type , valueId)} sx={{ flexGrow: 0.5, minWidth: "100px", height: "40px" }}>
                Search
              </Button>
            </Card>

            <Card>
              <Stack
                pr={3}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <UserListToolbar
                  numSelected={selected.length}
                  filterName={filterName}
                  onFilterName={handleFilterByName}
                />

                {/* <ExportCSV csvData={users} fileName='Student Data' /> */}
                <Button
                  variant="outlined"
                  onClick={() => setExportDialogOpen(true)}
                >
                  Export
                </Button>
                <Dialog open={exportDialogOpen} onClose={() => setExportDialogOpen(false)} maxWidth="sm" fullWidth>
                  <DialogTitle sx={{ fontWeight: 'bold', borderBottom: '1px solid #E2E8F0', pb: 2 }}>Export Column Selection</DialogTitle>
                  <DialogContent sx={{ mt: 2 }}>
                    <DialogContentText sx={{ mb: 2, fontWeight: '500', color: 'text.secondary' }}>
                      Select which columns you want to include in your CSV export:
                    </DialogContentText>
                    <FormGroup sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.enrollId} onChange={() => handleColumnToggle('enrollId')} />}
                        label="Enrollment No."
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.name} onChange={() => handleColumnToggle('name')} />}
                        label="Name"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.phone} onChange={() => handleColumnToggle('phone')} />}
                        label="Phone No."
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.email} onChange={() => handleColumnToggle('email')} />}
                        label="Email"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.category} onChange={() => handleColumnToggle('category')} />}
                        label="Stream/Category"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.value} onChange={() => handleColumnToggle('value')} />}
                        label="Batch/Test Series"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.purchaseAt} onChange={() => handleColumnToggle('purchaseAt')} />}
                        label="Purchased At"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.is_paid} onChange={() => handleColumnToggle('is_paid')} />}
                        label="Paid Status"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.is_active} onChange={() => handleColumnToggle('is_active')} />}
                        label="Status"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.amount} onChange={() => handleColumnToggle('amount')} />}
                        label="Amount"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.txnId} onChange={() => handleColumnToggle('txnId')} />}
                        label="Transaction ID"
                      />
                    </FormGroup>
                  </DialogContent>
                  <DialogActions sx={{ borderTop: '1px solid #E2E8F0', pt: 2, px: 3, pb: 2 }}>
                    <Button onClick={() => setExportDialogOpen(false)} color="inherit">
                      Cancel
                    </Button>
                    <CSVLink data={csvData} filename="PurchaseReport.csv" style={{ textDecoration: 'none' }} onClick={() => setExportDialogOpen(false)}>
                      <Button variant="contained" color="primary">
                        Download CSV
                      </Button>
                    </CSVLink>
                  </DialogActions>
                </Dialog>
                <Dialog open={open} onClose={handleClose}>
                  {download ? (
                    <>
                      <DialogTitle>OTP Varification</DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          OTP is send successfully to your regisered e-mail.
                        </DialogContentText>
                        <TextField
                          autoFocus
                          margin="dense"
                          id="name"
                          label="OTP Number"
                          type="number"
                          fullWidth
                          variant="standard"
                        />
                        <DialogContentText
                          sx={{
                            color: "red",
                            fontSize: "12px",
                            padding: "3px",
                          }}
                        >
                          {errorOTP}
                        </DialogContentText>
                      </DialogContent>

                      <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button onClick={verifyOtp}>Verify</Button>
                      </DialogActions>
                    </>
                  ) : (
                    <>
                      <DialogTitle>Download File</DialogTitle>
                      <DialogContent>
                        <CSVLink data={csvData} filename="AllUsers.csv" onClick={()=>handleClose()}>
                          Download
                        </CSVLink>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={() => {
                            handleClose();
                            setDownload(true);
                          }}
                        >
                          Cancel
                        </Button>
                      </DialogActions>
                    </>
                  )}
                </Dialog>
              </Stack>

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}
                      rowCount={users?.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                    />
                    <TableBody>
                      {/* {filterSearch?.map((row, index) => { */}
                      { filteredUsers && filteredUsers
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const { id, purchaseAt,is_active,  is_paid } = row;
                          const {
                            userId,
                            enrollId,
                            icon,
                            name,
                            phone,
                            email,
                          } = row?.user || {};
                          // console.log('row',row)
                          const isItemSelected = selected.indexOf(name) !== -1;
                          // row.sno = index + 1 + rowsPerPage * page
                          // debugger;
                          // console.log( is_active + " "+ typeof(is_active))
                          return (
                            <TableRow
                              hover
                              key={index}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                            >
                              {/* <TableCell padding="checkbox">
                            <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, StudentName)} />
                          </TableCell> */}
                              <TableCell>
                                <Typography variant="subtitle2" noWrap>
                                  {/* {index + 1} */}
                                  {/* {row.sno} */}
                                  {index + 1 + rowsPerPage * page}
                                </Typography>
                              </TableCell>

                              <TableCell>
                                <Typography variant="subtitle2" noWrap>
                                  {enrollId}
                                </Typography>
                              </TableCell>

                              <TableCell component="th" scope="row" pl={2}>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={2}
                                >
                                  <Avatar
                                    alt={name}
                                    src={icon}
                                    sx={{ width: 28, height: 28 }}
                                  />
                                  <Typography variant="subtitle2" noWrap>
                                    {name}
                                  </Typography>
                                </Stack>
                              </TableCell>
                              <TableCell align="left">
                                {phone ? phone : "NA"}
                              </TableCell>
                              <TableCell align="left">{email}</TableCell>
                              <TableCell align="left">{row?.value ? row.value : "N/A"}</TableCell>
                              <TableCell align="left">{purchaseAt ? formatDateTimeIST(purchaseAt) : "N/A"}</TableCell>
                              <TableCell align="left">
                                {is_paid ? (
                                  <span style={{ color: "green" }}>Paid</span>
                                ) : (
                                  <span style={{ color: "red" }}>Not paid</span>
                                )}
                              </TableCell>
                              <TableCell align="left">
                                { is_active ? (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    color="success"
                                    onClick={() => {
                                      handleClickOpen();
                                      sendOtp();
                                      setStatusStatus(is_active);
                                      setStatusUser(id);
                                    }}
                                  >
                                    Active
                                  </Button>
                                ) : (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    color="error"
                                    onClick={() => {
                                      handleClickOpen();
                                      sendOtp();
                                      setStatusStatus(is_active);
                                      setStatusUser(id);
                                    }}
                                  >
                                    InActive
                                  </Button>
                                )}
                              </TableCell>
                              <TableCell align="left">
                                <Button
                                  variant="outlined"
                                  size="small"
                                  color="error"
                                  onClick={() =>
                                    navigate(
                                      `/dashboard/students/studentsProfile/${userId}`
                                    )
                                  }
                                >
                                  view
                                </Button>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>

                    {isUserNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <SearchNotFound searchQuery={filterName} />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredUsers.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>
          </Container>
          <ToastContainer
            position="bottom-center"
            autoClose={1000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </Page>
      )}
    </>
  );
}
